import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Map from '../../features/map';

function PublicMapLayout() {
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      {/* Main Content - Full screen map without sidebar */}
      <div style={{ height: '100%', width: '100%' }}>
        <Routes>
          {/* When accessing /public-map, show the Map */}
          <Route path="/" element={<Map />} />
          {/* Redirect /public-map/ to /public-map */}
          <Route path="*" element={<Navigate to="/public-map" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default PublicMapLayout;
